module.exports = "/build/web/images/placeholder/article-header-mobile.abf038482c1a793bf942ba9fa5b43736.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/placeholder/article-header-mobile.jpg
// module id = 135
// module chunks = 24